import { assetRelationTypeSchema } from '@aikoa/common'
import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import z from 'zod/v4'
import { PhaseWrapper } from '~/components/flows/phases/PhaseWrapper.tsx'
import Icon from '~/components/Icon.tsx'
import { ViewTitle } from '~/components/layout/Sections.tsx'
import { Body } from '~/components/typography/Content.tsx'
import { Heading3 } from '~/components/typography/Titles.tsx'
import { ToggleButton } from '~/components/ui/toggle-button'

export const dataEntryMethodSchema = z.object({
  dataEntryMethod: z.enum(['url', 'document', 'linear', 'manual']),
  relationType: assetRelationTypeSchema,
})

export type DataEntryMethodData = z.infer<typeof dataEntryMethodSchema>

export function DataEntryMethodPhase({
  selectedMethod,
  onSelect,
}: {
  selectedMethod?: DataEntryMethodData
  onSelect: (method: DataEntryMethodData) => unknown
}) {
  const { t } = useTranslations('property')

  const dataEntryMethods = [
    {
      id: 'manual' as const,
      icon: 'edit' as const,
      title: t(($) => $.flow.dataEntryMethod.methods.manual.title),
      description: t(($) => $.flow.dataEntryMethod.methods.manual.description),
      disabled: false,
      relationType: 'prospect' as const,
    },
    {
      id: 'url' as const,
      icon: 'globe' as const,
      title: t(($) => $.flow.dataEntryMethod.methods.url.title),
      description: t(($) => $.flow.dataEntryMethod.methods.url.description),
      disabled: false,
      relationType: 'representation' as const,
    },
    /*  {
      id: 'document' as const,
      icon: 'document-attach-outline' as const,
      title: 'Tuo dokumentista',
      description: 'Hae tiedot PDF- tai kuvatiedostosta.',
      disabled: true,
    }, */
    /* {
      id: 'linear' as const,
      icon: 'cloud-download-outline' as const,
      title: 'Tuo Linearista',
      description: 'Tuo tiedot Linearista (Tulossa pian)',
      disabled: true,
    }, */
  ]

  return (
    <PhaseWrapper>
      <ViewTitle>{t(($) => $.flow.dataEntryMethod.title)}</ViewTitle>

      <View className="gap-2">
        {dataEntryMethods.map((method) => (
          <ToggleButton
            key={method.id}
            value={selectedMethod?.dataEntryMethod === method.id}
            disabled={method.disabled}
            onValueChange={() => {
              onSelect({
                dataEntryMethod: method.id,
                relationType: method.relationType,
              })
            }}>
            <View className="flex-row items-center gap-4">
              <Icon
                name={method.icon}
                size={22}
                className="mt-0.5 shrink-0 self-start text-primary"
              />
              <View className="flex-1">
                <Heading3>{method.title}</Heading3>
                <Body>{method.description}</Body>
              </View>
            </View>
          </ToggleButton>
        ))}
      </View>
    </PhaseWrapper>
  )
}
